module.exports = __webpack_public_path__ + "static/media/scooter-sm.7f955374.png";